import { memo } from "react";
import TablePagination from "@mui/material/TablePagination";

import {
  COMMUNICATIONS_TABLE_ROWS_PER_PAGE_OPTIONS,
} from "../hooks/useTablePagination";

export interface CommunicationsTablePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (_: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Rodapé de paginação padronizado (paridade com `PatientSelectionList`).
 */
const CommunicationsTablePagination = memo(
  ({
    count,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
  }: CommunicationsTablePaginationProps) => {
    if (count === 0) return null;

    return (
      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[...COMMUNICATIONS_TABLE_ROWS_PER_PAGE_OPTIONS]}
        labelRowsPerPage="Itens por página:"
        labelDisplayedRows={({ from, to, count: total }) =>
          `${from}-${to} de ${total}`
        }
        sx={{ px: 0.5 }}
      />
    );
  },
);

CommunicationsTablePagination.displayName = "CommunicationsTablePagination";

export default CommunicationsTablePagination;
